import {IThemeIcons} from '../architecture/sections/theme-icons.interface';
import {MobileMenuIcon} from './icons/mobile-menu.icon';
import {InfoIcon} from './icons/info.icon';
import {AddIcon} from './icons/add.icon';
import {BackIcon} from './icons/back.icon';
import {ForwardIcon} from './icons/forward.icon';
import {CloseIcon} from './icons/close.icon';
import {ControlCenterIcon} from './icons/control-center.icon';
import {HelpIcon} from './icons/help.icon';
import {TwoCharsIcon} from './icons/two-chars.icon';
import {EarthGlobeIcon} from './icons/earth-globe.icon';
import {TopGamesIcon} from './icons/live-arena-navbar/top-games.icon';
import {RouletteIcon} from './icons/live-arena-navbar/roulette.icon';
import {BlackjackIcon} from './icons/live-arena-navbar/blackjack.icon';
import {EliteLoungeIcon} from './icons/live-arena-navbar/elite-lounge.icon';
import {PokerIcon} from './icons/live-arena-navbar/poker.icon';
import {BaccaratIcon} from './icons/live-arena-navbar/baccarat.icon';
import {GameShowsIcon} from './icons/live-arena-navbar/game-shows.icon';
import {NewGamesIcon} from './icons/live-arena-navbar/new-games.icon';
import {LinkToOfferIcon} from "./icons/link-to-offer.icon";
import {LinkToOfferCloseIcon} from "./icons/link-to-offer-close.icon";
import {SourceOfFundsIcon} from "./icons/source-of-funds.icon";
import {ArrowsUpDownIcon} from "./icons/arrows-up-down.icon";
import {MegaphoneIcon} from "./icons/megaphone.icon";
import {ChipIcon} from "./icons/chip.icon";
import {SettingsIcon} from "./icons/settings.icon";
import {MuteIcon} from "./icons/live-arena-tile/mute.icon";
import {UnmuteIcon} from "./icons/live-arena-tile/unmute.icon";
import {ViewersIcon} from "./icons/live-arena-tile/viewers.icon";
import {BrokenLinkIcon} from "./icons/live-arena-tile/broken-link.icon";
import {TimeReminderIcon} from "./icons/time-reminder.icon";
import {TripleEightExclusiveIcon} from "./icons/live-arena-navbar/triple-eight-exclusive.icon";
import {PaymentsRedirectIcon} from "./icons/payments-redirect.icon";
import {LeftArrowIcon} from "./icons/live-arena-tile/left-arrow.icon";
import {RightArrowIcon} from "./icons/live-arena-tile/right-arrow.icon";
import {LocationIcon} from "./icons/location.icon";
import {SearchIcon} from './icons/search.icon';
import {BlogIcon} from './icons/side-menu/blog.icon';
import {HomeIcon} from './icons/side-menu/home.icon';
import {PromotionsIcon} from './icons/side-menu/promotions.icon';
import {SlotsIcon} from './icons/side-menu/slots.icon';
import {JackpotsIcon} from './icons/side-menu/jackpots.icon';
import {LiveCasinoIcon} from './icons/side-menu/live-casino.icon';
import {CasinoGamesIcon} from './icons/side-menu/casino-games.icon';
import {VipIcon} from './icons/side-menu/vip.icon';
import {NewGamesIcon as SideMenuNewGamesIcon} from './icons/side-menu/new-games.icon';
import {TripleEightCasinoIcon} from "./icons/side-menu/888casino.icon";
import {BlackjackIcon as SideMenuBlackjackIcon} from './icons/side-menu/blackjack.icon';
import {RouletteIcon as SideMenuRouletteIcon} from './icons/side-menu/roulette.icon';
import {GettingStartedIcon} from "./icons/side-menu/getting-started.icon";
import {BankingIcon} from "./icons/side-menu/banking.icon";
import {LiveChatIcon} from "./icons/side-menu/live-chat.icon";
import {DownloadAppIcon} from "./icons/side-menu/download-app.icon";
import {Club888Icon} from "./icons/side-menu/club888.icon";
import {PokerCircleIcon} from "./icons/side-menu/poker-circle.icon";
import {SportCircleIcon} from "./icons/side-menu/sport-circle.icon";
import {VideoPokerIcon} from "./icons/side-menu/video-poker.icon";
import {DepositIcon} from "./icons/side-menu/deposit.icon";
import {FreePlayIcon} from "./icons/freeplay.icon";
import {NotificationIcon} from "./icons/notifications.icon";
import {HelpCenterIcon} from "./icons/help-center.icon";
import {WarningSignIcon} from "./icons/warning-sign.icon";
import {USAMapIcon} from "./icons/usa-map.icon";
import {ScratchCardsIcon} from './icons/side-menu/scratch-cards.icon';
import {MobileMenuNoSearchIcon} from "./icons/mobile-menu-no-search.icon";
import {SpeedGamesIcon} from "./icons/live-arena-navbar/speed-games.icon";
import {FilterIcon} from "./icons/filter.icon";
import {TempAccountPopupIcon} from "./icons/temp-account-popup.icon";
import {MobileAppsIcon} from "./icons/side-menu/mobile-apps.icon";
import {AppHeaderSportIcon} from "./icons/header-navbar/app-header-sport.icon";
import {AppHeaderPokerIcon} from "./icons/header-navbar/app-header-poker.icon";
import {AppHeaderLogo888Icon} from "./icons/header-navbar/app-header-logo-888.icon";
import {AppHeaderCasinoIcon} from "../definitions/mrgreen/icons/header-navbar/app-header-casino.icon";
import {SelfExclusionRegulationIcon} from "./icons/header-navbar/regulation-icons/self-exclusion.icon";
import {SelfExclusionRegulationSymbolIcon} from "./icons/header-navbar/regulation-icons/self-exclusion-symbol.icon";
import {GamingLimitRegulationIcon} from "./icons/header-navbar/regulation-icons/gaming-limit.icon";
import {GamingLimitRegulationSymbolIcon} from "./icons/header-navbar/regulation-icons/gaming-limit-symbol.icon";
import {SelfTestRegulationIcon} from "./icons/header-navbar/regulation-icons/self-test.icon";
import {SelfTestRegulationSymbolIcon} from "./icons/header-navbar/regulation-icons/self-test-symbol.icon";
import {MinimumGamblingAgeRegulationIcon} from "./icons/header-navbar/regulation-icons/minimum-gambling-age.icon";
import {PanicButtonRegulationIcon} from "./icons/header-navbar/regulation-icons/panic-button.icon";
import {HistoryIcon} from './icons/history.icon';
import {TransactionHistoryIcon} from './icons/transaction-history.icon';
import {SecurityIcon} from './icons/security.icon';
import {CompPointsIcon} from './icons/comp-points.icon';
import {TimerIcon} from './icons/timer.icon';
import {BiometricLoginIcon} from './icons/biometric-login.icon';
import {AboutIcon} from './icons/about.icon';
import {GamingHistoryIcon} from './icons/gaming-history.icon';
import {UploadDocumentsIcon} from './icons/upload-documents.icon';
import {TippingHistoryIcon} from './icons/tipping-history.icon';
import {ReverseWithdrawalIcon} from './icons/reverse-withdrawal.icon';
import {OpenExternalIcon} from './icons/open-external.icon';
import {WalletIcon} from './icons/wallet.icon';
import {RegisterUserIcon} from './icons/register-user.icon';
import {SaveGameIcon} from "./icons/save-game.icon";
import {PokerChipIcon} from './icons/side-menu/poker-chip.icon';
import {SportFootballIcon} from './icons/side-menu/sport-football.icon';
import {ForYouIcon} from "./icons/for-you.icon";
import {RedRecordCircleIcon} from './icons/live-arena-tile/red-record-circle.icon';
import {LeaveIcon} from './icons/leave.icon';
import {SoundOnIcon} from "./icons/sound-on.icon";
import {SoundOffIcon} from "./icons/sound-off.icon";

export const ThemeDefaultIcons: IThemeIcons = {
    mobileAppsIcon: MobileAppsIcon,
    mobileMenuNoSearchIcon: MobileMenuNoSearchIcon,
    mobileMenuIcon: MobileMenuIcon,
    addIcon: AddIcon,
    infoIcon: InfoIcon,
    backIcon: BackIcon,
    forwardIcon: ForwardIcon,
    closeIcon: CloseIcon,
    controlCenterIcon: ControlCenterIcon,
    appHeaderPokerIcon: AppHeaderPokerIcon,
    appHeaderSportIcon: AppHeaderSportIcon,
    appHeaderCasinoIcon: AppHeaderCasinoIcon,
    appHeaderLogo888Icon: AppHeaderLogo888Icon,
    helpIcon: HelpIcon,
    twoCharsIcon: TwoCharsIcon,
    earthGlobeIcon: EarthGlobeIcon,
    topGamesIcon: TopGamesIcon,
    rouletteIcon: RouletteIcon,
    blackjackIcon: BlackjackIcon,
    eliteLoungeIcon: EliteLoungeIcon,
    pokerIcon: PokerIcon,
    baccaratIcon: BaccaratIcon,
    gameShowsIcon: GameShowsIcon,
    newGamesIcon: NewGamesIcon,
    linkToOfferIcon: LinkToOfferIcon,
    linkToOfferCloseIcon: LinkToOfferCloseIcon,
    sourceOfFundsIcon: SourceOfFundsIcon,
    arrowsUpDownIcon: ArrowsUpDownIcon,
    megaphoneIcon: MegaphoneIcon,
    chipIcon: ChipIcon,
    settingsIcon: SettingsIcon,
    muteIcon: MuteIcon,
    redRecordCircle: RedRecordCircleIcon,
    unmuteIcon: UnmuteIcon,
    viewersIcon: ViewersIcon,
    brokenLinkIcon: BrokenLinkIcon,
    timeSpentReminderClockIcon: TimeReminderIcon,
    tripleEightExclusiveIcon: TripleEightExclusiveIcon,
    paymentsRedirectIcon: PaymentsRedirectIcon,
    leftArrowIcon: LeftArrowIcon,
    rightArrowIcon: RightArrowIcon,
    locationIcon: LocationIcon,
    searchIcon: SearchIcon,
    sideMenuHome: HomeIcon,
    sideMenuBlog: BlogIcon,
    sideMenuPromotions: PromotionsIcon,
    sideMenuSlots: SlotsIcon,
    sideMenuJackpots: JackpotsIcon,
    sideMenuLiveCasino: LiveCasinoIcon,
    sideMenuVip: VipIcon,
    sideMenuNewGames: SideMenuNewGamesIcon,
    sideMenuCasinoGames: CasinoGamesIcon,
    sideMenuExclusive888: TripleEightCasinoIcon,
    sideMenuScratchCards: ScratchCardsIcon,
    sideMenuBlackjack: SideMenuBlackjackIcon,
    sideMenuRoulette: SideMenuRouletteIcon,
    sideMenuGettingStarted: GettingStartedIcon,
    sideMenuBanking: BankingIcon,
    sideMenuLiveChat: LiveChatIcon,
    sideMenuDownloadApp: DownloadAppIcon,
    sideMenuClub888: Club888Icon,
    sideMenuPokerCircle: PokerCircleIcon,
    sideMenuSportCircle: SportCircleIcon,
    sideMenuVideoPoker: VideoPokerIcon,
    sideMenuDeposit: DepositIcon,
    sideMenuPokerChip: PokerChipIcon,
    sideMenuSportFootball: SportFootballIcon,
    notificationIcon: NotificationIcon,
    freeplayIcon: FreePlayIcon,
    helpCenterIcon: HelpCenterIcon,
    warningSignIcon: WarningSignIcon,
    usaMapIcon: USAMapIcon,
    speedGames: SpeedGamesIcon,
    filterIcon: FilterIcon,
    tempAccountPopupIcon: TempAccountPopupIcon,
    selfExclusionRegulationIcon: SelfExclusionRegulationIcon,
    selfExclusionRegulationSymbolIcon: SelfExclusionRegulationSymbolIcon,
    gamingLimitRegulationIcon: GamingLimitRegulationIcon,
    gamingLimitRegulationSymbolIcon: GamingLimitRegulationSymbolIcon,
    selfTestRegulationIcon: SelfTestRegulationIcon,
    selfTestRegulationSymbolIcon: SelfTestRegulationSymbolIcon,
    minimumGamblingAgeRegulationIcon: MinimumGamblingAgeRegulationIcon,
    panicButtonRegulationIcon: PanicButtonRegulationIcon,
    historyIcon: HistoryIcon,
    transactionHistoryIcon: TransactionHistoryIcon,
    securityIcon: SecurityIcon,
    compPointsIcon: CompPointsIcon,
    timerIcon: TimerIcon,
    biometricLoginIcon: BiometricLoginIcon,
    aboutIcon: AboutIcon,
    gamingHistoryIcon: GamingHistoryIcon,
    uploadDocumentsIcon: UploadDocumentsIcon,
    tippingHistoryIcon: TippingHistoryIcon,
    reverseWithdrawalIcon: ReverseWithdrawalIcon,
    openExternal: OpenExternalIcon,
    wallet: WalletIcon,
    registerUser: RegisterUserIcon,
    forYouIcon: ForYouIcon,
    saveGameIcon: SaveGameIcon,
    leaveIcon: LeaveIcon,
    soundOnIcon: SoundOnIcon,
    soundOffIcon: SoundOffIcon
};
